import Button from "components/button/default";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type IProps = {
  isPrevBtn?: boolean;
  disabled: boolean;
  btnTxt?: string;
  handleNext(): void;
};

export default function JoinBtnWrap({
  isPrevBtn = true,
  disabled,
  btnTxt = "btn_nxt_sng",
  handleNext,
}: IProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex gap-2">
      {isPrevBtn && (
        <button
          className="btn join-prev"
          onClick={() => {
            navigate(-1);
          }}
        />
      )}
      <Button
        text={t(btnTxt)}
        styels="join-next"
        onClick={handleNext}
        disabled={disabled}
      />
    </div>
  );
}
